import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  role?: 'team' | 'speaker';
};

export function RequireAuth({ children, role }: Props) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (role && session.role !== role) {
    return (
      <Navigate to={session.role === 'team' ? '/events' : '/me'} replace />
    );
  }
  return <>{children}</>;
}
